import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-to-resize-a-gif";

export const Route = createFileRoute("/blog/how-to-resize-a-gif")(options);
